<div class="el-contact-wrapper">
    <div class="container">
        <div class="el-contact-flex">
            <div class="el-contact-left-flex">
                <div class="el-contact-left-image" style="margin-bottom: -80px;">
                    <img src="../assets/images/all-instructor/contact-image.png" alt="Image" class="el-contact-image">
                    <img [src]="dynamicImage" alt="image" class="el-contact-review">
                    <img src="../assets/images/all-instructor/students.png" alt="image" class="el-contact-student">
                    <img src="../assets/images/all-instructor/banner-arrow2.svg" alt="Arrow Shape"
                        class="el-contact-arrow">
                    <img src="../assets/images/all-instructor/star-smile.png" alt="star smile" class="el-contact-star">
                </div>
                <!-- <div class="el-contact-left-form">
                    <img src="../assets/images/all-instructor/registration.png" alt="video icon">
                    <div class="el-contact-form-box">
                        <form>
                            <div class="el-contact-form-head">
                                <h4>Sign Up Here !!
                                </h4>
                                <p class="el-para">Get details in your inbox right now</p>
                            </div>
                            <div class="el-input-field">
                                <input type="text" placeholder="Full Name">
                            </div>
                            <div class="el-input-field">
                                <input type="text" placeholder="Email ID">
                            </div>
                            <div class="el-input-field">
                                <input type="number" placeholder="Mobile Number">
                            </div>
                            <div class="el-input-field">
                                <select class="mySelect">
                                    <option>Course</option>
                                    <option>English</option>
                                    <option>Maths</option>
                                    <option>Science</option>
                                </select>
                            </div>
                            <div class="el-input-field-flex">
                                <div class="el-input-field">
                                    <select class="mySelect">
                                        <option>Male</option>
                                        <option>Female</option>
                                    </select>
                                </div>
                                <div class="el-input-field">
                                    <input type="text" id="datepicker" class="date" readonly="readonly"
                                        placeholder="Date of birth">
                                </div>
                            </div>
                            <div class="el-contact-form-btn">
                                <a href="javascript:;" class="el-btn">Submit</a>
                            </div>
                        </form>
                    </div>
                </div> -->
            </div>
            <div class="el-contact-right">
                <div class="el-about-content">
                    <h4 class="el-top-heading">Enrol Now</h4>
                    <h2 class="el-main-heading">Register Now & Master the <br>
                        Mock Test!</h2>
                    <p class="el-para">Get ahead in the competition with expertly crafted mock tests from PowerPrep,
                        designed to mirror real Olympiad exam
                        patterns. Each test is built with accuracy and consistency to strengthen core concepts, boost
                        confidence, and track
                        analytical progress, helping students aim for brilliance in every attempt.</p>
                    <p class="el-para">Begin your journey today with PowerPrep and stand out with top performance in the
                        Olympiads through focused, goal-driven
                        practice and results!
                    </p>
                    <a [routerLink]="['/dashboard']" class="el-btn">enrol now</a>
                </div>
            </div>
        </div>
    </div>
</div>